import {NfMessage, NfMessageType} from "../NfMessage";
//@ts-ignore
import {ReservationSearchData} from "../Models/ReservationSearchData";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";
import {RoomPeopleConfiguration} from "../Models/RoomPeopleConfiguration";

/**
 * Wiadomość, gdy użytkownik zmienił filtry wyszukiwania dostępności (np. datę), do i z service workera
 * service worker wysyła tą wiadomość do wszystkich podkomponentów, gdy się filtry zmienią
 */
export class SetReservationSearchData extends NfComponentGlobalMessage {
    declare serializedReservationSearchData: any;
    public persistentMessage = true;
    public constructor(sourceComponentId: number|MessageEvent<SetReservationSearchData>, reservationSearchData?:ReservationSearchData,
                       public alreadySearched = false) {
        super(NfMessageType.SetReservationSearchData, arguments.length > 1);
        if(NfMessage.isMessageEvent(sourceComponentId)) {
            Object.assign(this, sourceComponentId.data);
        } else {
            this.sourceComponentId = sourceComponentId;
            if(!reservationSearchData) {
                throw Error('reservationSearchData is required');
            }
            this.serializedReservationSearchData = this.serialize(reservationSearchData);
        }
    }
    public getReservationSearchData():ReservationSearchData {
        return ReservationSearchData.deserialize(this.deserialize(this.serializedReservationSearchData));
    }
}
NfMessage.creationCallbacks[NfMessageType.SetReservationSearchData] = (event) => {
    const message =  new SetReservationSearchData(event);
    return message;
}
